// Global Footer Component para Alpine.js

import Alpine from 'alpinejs';

Alpine.data('globalFooter', () => ({
  isOnline: navigator.onLine,
  globalPending: 0,
  isSyncing: false,

  async init() {
    // Update every 2 seconds
    setInterval(async () => {
      this.isOnline = navigator.onLine;
      
      // Get global pending count from SyncManager if available
      // For now, placeholder
      this.globalPending = 0;
      this.isSyncing = this.globalPending > 0 && this.isOnline;
    }, 2000);
    
    window.addEventListener('online', () => this.isOnline = true);
    window.addEventListener('offline', () => this.isOnline = false);
  },

  goToSettings() {
    // Navigate to settings (placeholder)
    window.location.href = '/settings';
  },
}));

